module.exports = __webpack_public_path__ + "fa-regular-400.bdadb.woff2";